import { useEffect } from 'react';
export const useEvent = (target, type, listener, deps) => {
    useEffect(() => {
        target.addEventListener(type, listener);
        return () => target.removeEventListener(type, listener);
    }, deps);
};
